import Swiper from 'swiper';

const initCarousel = () => {
	const components = document.querySelectorAll( 'section.carousel' );

	if ( !components.length )
	{
		return;
	}

	components.forEach( ( component ) => {		

		if ( !component.classList.contains( 'list' ) )
		{
			const slidesWrapper = component.querySelector( 'ul.swiper-wrapper' );
			const currentSlider = component.querySelector( 'div.swiper' );

			const swiper = new Swiper( currentSlider, {
				slidesPerView: 'auto',
				freeMode: true,
			} );

			swiper.on( 'touchStart', () => {
				slidesWrapper.classList.add( 'with-mouse' );
				component.classList.add( 'with-mouse' );
			});
		}
	} );
};

export {
	initCarousel,
};
